/** @format */

import { ApiFetch } from "../../../shared/utils/fetch";

export interface Category {
  id: string;
  name: string;
  adminId: string;
  createdAt: string;
  updatedAt: string;
}
export interface Color {
  name: string;
  hexValue: string;
  id: string;
}

export interface Size {
  id: string;
  name: string;
  order: number;
  createdAt: string;
  updatedAt: string;
}

export interface Material {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface Size_Guide {
  id: string;
  name: string;
  description: string;
  imageUrl: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null;
}
export interface Meta {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string;
  endCursor: string;
  totalCount: number;
}
export interface Links {
  first: string;
  next?: string;
}
interface MetaObj {
  meta: Meta;
  links: Links;
}
export interface CategoriesResponse {
  data: Category[];
  meta: Meta;
  links: Links;
}

export interface ColorsResponse {
  data: Color[];
  meta: MetaObj;
}

export interface SizeResponse {
  data: Size[];
  meta: MetaObj;
}

export interface MaterialsResponse {
  data: Material[];
  meta: Meta;
  links: Links;
  execution_time_ms: number;
}


export interface SizeGuideResponse {
  execution_time_ms: number;
  result: {
    data: Size_Guide[];
    meta: Meta;
    links: Links;
  };
}

export const metaDataApi = {
  getAllCategories: (): Promise<CategoriesResponse> => {
    return ApiFetch.get<CategoriesResponse>("/categories");
  },

  getAllColors: (): Promise<ColorsResponse> => {
    return ApiFetch.get<ColorsResponse>("/colours");
  },
  getAllSizeGuides: (): Promise<SizeGuideResponse> => {
    return ApiFetch.get<SizeGuideResponse>("/size-guides");
  },
  getAllMaterials: (): Promise<MaterialsResponse> => {
    return ApiFetch.get<MaterialsResponse>("/materials");
  },
  getAllSizes: (): Promise<SizeResponse> => {
    return ApiFetch.get<SizeResponse>("/sizes");
  },

  createCategory: (name: string): Promise<Category> => {
    return ApiFetch.post<Category>("/categories", { name });
  },
  updateCategory: (id: string, name: string): Promise<Category> => {
    return ApiFetch.put<Category>(`/categories/${id}`, { name });
  },
  deleteCategory: (id: string): Promise<void> => {
    return ApiFetch.del<void>(`/categories/${id}`);
  },
  createSize: (name: string, order: number): Promise<Size> => {
    return ApiFetch.post<Size>("/sizes", { name, order });
  },
  updateSize: (id: string, name: string): Promise<Size> => {
    return ApiFetch.put<Size>(`/sizes/${id}`, { name });
  },
  deleteSize: (id: string): Promise<void> => {
    return ApiFetch.del<void>(`/sizes/${id}`);
  },
  createMaterial: (name: string): Promise<Material> => {
    return ApiFetch.post<Material>("/materials", { name });
  },
  updateMaterial: (id: string, name: string): Promise<Material> => {
    return ApiFetch.put<Material>(`/materials/${id}`, { name });
  },
  deleteMaterial: (id: string): Promise<void> => {
    return ApiFetch.del<void>(`/materials/${id}`);
  },
  createColor: (name: string, hexValue: string): Promise<Color> => {
    return ApiFetch.post<Color>("/colours", { name, hexValue });
  },
  updateColor: (id: string, name: string, hexValue: string): Promise<Color> => {
    return ApiFetch.put<Color>(`/colours/${id}`, { name, hexValue });
  },
  deleteColor: (id: string): Promise<void> => {
    return ApiFetch.del<void>(`/colours/${id}`);
  },

  createSizeGuide: (formData: FormData): Promise<Size_Guide> => {
    return ApiFetch.post<Size_Guide>("/size-guides", formData, true);
  },
  updateSizeGuide: (id: string, formData: FormData): Promise<Size_Guide> => {
    return ApiFetch.put<Size_Guide>(`/size-guides/${id}`, formData, true);
  },
  deleteSizeGuide: (id: string): Promise<void> => {
    return ApiFetch.del<void>(`/size-guides/${id}`);
  },
};
